export default {"src":"/_next/static/media/Liver-and-Pancreatic-Cancer.287c91be.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};